export const STRIPE_JS_URL = 'https://js.stripe.com/v3';
